import BlackBird from 'shared/blackbird'

export function useGetWebhookId() {
  const query = BlackBird.getQuery<{ id?: string }>()
  const webhookId = query.id
  const isCreation = !webhookId

  return {
    webhookId,
    isCreation
  }
}
